import { Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { useIsSmallBreakpoint } from "../../utils/useBreakpoints";

export function OnboardingStepTitles({
  activeStep,
  isNewOnboarding,
}: {
  activeStep: number;
  isNewOnboarding: boolean;
}) {
  const isSmall = useIsSmallBreakpoint();

  const classicStepTitles = [
    {
      title: t("components.onboarding.comicTypes.title"),
    },
    {
      title: t("components.onboarding.comicGenres.title"),
    },
    {
      title: t("components.onboarding.comicThemes.title"),
    },
  ];

  const newStepTitles = [
    {
      title: t("components.onboarding.archetype.title"),
    },
  ];

  const stepTitles = isNewOnboarding ? newStepTitles : classicStepTitles;
  const title = stepTitles[activeStep]?.title;

  if (!title) {
    return null;
  }
  return (
    <Flex
      p={
        isSmall
          ? "24px 24px 0px 24px"
          : isNewOnboarding
            ? "48px 48px 20px 48px"
            : "24px"
      }
      flexDirection="column"
      gap="8px"
      maxWidth={isSmall ? "100%" : "80%"}
    >
      {title && (
        <Text
          variant="onboardingTitle"
          textAlign={isSmall && isNewOnboarding ? "center" : "left"}
        >
          {title}
        </Text>
      )}
      {isNewOnboarding ? (
        <Text
          textAlign={isSmall ? "center" : "left"}
          variant="onboardingSubtitle"
        >
          {t("components.onboarding.archetype.subtitle")}
        </Text>
      ) : null}
    </Flex>
  );
}
